<template>
    <div>
        <h3>本文の規約</h3>
        <div>
            <p>
                貸し本棚における、本文記述の規約について説明します。
                「このように書かなければ表示が崩れる」といった必須の規約と、
                「文字打ち」で本文を表示している読者にとって読みづらくならないためのガイドラインを示します。
            </p>
            <h4>必須の規約</h4>
            <h5>一単語に半角と全角を混在させないでください</h5>
            <p>
                例えばドメイン名「example．com」のようにしてしまうと、縦書きのときに「com」が縦中横になってしまいます。
                顔文字などでこのトラブルが頻発します。
            </p>
            <h5>半角括弧と二重山括弧（《》）は表示できないことがあります</h5>
            <p>
                いずれもルビ振り用の記号として扱われます。
                文字打ちのときは、これらの括弧に囲われた文字は一気に出力します。
            </p>
            <h4>ガイドライン</h4>
            <h5>行頭のスペース文字で改行</h5>
            <p>
                行頭に全角スペースを打って改行すると、文字打ちのときに入力待ちが発生します。
                これを繰り返して行間を空けてしまうと、一行ごとに入力待ちが発生し、読者の離脱の原因になります。
            </p>
            <h5>長大な段落</h5>
            <p>
                一画面に収まりきれないほどの長い段落を書く場合、
                文字打ちにおいて、改行まで止まらずに打ち出されることを忘れないでください。
                タブレットやスマートフォンでは文字打ちの一時停止ができないため、
                読者の読む速度が追いつかないと、スクロールして本文を遡る必要が生じます。
            </p>
            <h5>連続するスペース文字</h5>
            <p>
                文字打ちにおいて、スペース文字はカーソル音が鳴りません。
                カーソル音を期待して連続するスペース文字を使うことは意味がありません。
            </p>
        </div>
    </div>
</template>

<style src="../help.scss" scoped lang="scss"></style>

<script>
export default {
    created() {
        this.useHead({
            title: "本文の規約 | 貸し本棚ヘルプ",
            link: [
                {
                    rel: "canonical",
                    href: location.origin + location.pathname,
                    id: "canonical"
                }
            ]
        });
    }
}
</script>